import {
    BuildingPrimaryPropertyType,
    type BuildingPrimaryPropertyType as BuildingPrimaryPropertyTypeValue,
} from '@quipex/shared/contracts';
import { BUILDING_SCENERY_PLACEHOLDER } from './building-scenery-placeholders';

export type BuildingSceneryImage = {
    readonly src: string;
    readonly placeholder: string;
};

const BUILDING_SCENERY_IMAGE: Readonly<
    Record<BuildingPrimaryPropertyTypeValue, string>
> = {
    [BuildingPrimaryPropertyType.HouseTownhouseVilla]:
        '/assets/images/building-scenery/01-house-townhouse-villa.webp',
    [BuildingPrimaryPropertyType.DuplexSemiDetached]:
        '/assets/images/building-scenery/02-duplex-semi-detached.webp',
    [BuildingPrimaryPropertyType.BoardingHouseGuestHouse]:
        '/assets/images/building-scenery/03-boarding-house-guest-house.webp',
    [BuildingPrimaryPropertyType.ApartmentUnitBlock]:
        '/assets/images/building-scenery/04-apartment-unit-block.webp',
    [BuildingPrimaryPropertyType.HotelMotelHostel]:
        '/assets/images/building-scenery/05-hotel-motel-hostel.webp',
    [BuildingPrimaryPropertyType.CaretakersResidenceWithinNonResidential]:
        '/assets/images/building-scenery/06-caretaker-s-residence-within-non-residential.webp',
    [BuildingPrimaryPropertyType.AgedCareFacility]:
        '/assets/images/building-scenery/07-aged-care-facility.webp',
    [BuildingPrimaryPropertyType.RetirementVillage]:
        '/assets/images/building-scenery/08-retirement-village.webp',
    [BuildingPrimaryPropertyType.OfficeBuilding]:
        '/assets/images/building-scenery/09-office-building.webp',
    [BuildingPrimaryPropertyType.GpMedicalPractice]:
        '/assets/images/building-scenery/10-gp-medical-practice.webp',
    [BuildingPrimaryPropertyType.RetailShop]:
        '/assets/images/building-scenery/11-retail-shop.webp',
    [BuildingPrimaryPropertyType.RestaurantCafeBar]:
        '/assets/images/building-scenery/12-restaurant-cafe-bar.webp',
    [BuildingPrimaryPropertyType.Showroom]:
        '/assets/images/building-scenery/13-showroom.webp',
    [BuildingPrimaryPropertyType.ShoppingCentre]:
        '/assets/images/building-scenery/14-shopping-centre.webp',
    [BuildingPrimaryPropertyType.CarPark]:
        '/assets/images/building-scenery/15-car-park.webp',
    [BuildingPrimaryPropertyType.WarehouseStorage]:
        '/assets/images/building-scenery/16-warehouse-storage.webp',
    [BuildingPrimaryPropertyType.FactoryManufacturing]:
        '/assets/images/building-scenery/17-factory-manufacturing.webp',
    [BuildingPrimaryPropertyType.LaboratoryWorkshop]:
        '/assets/images/building-scenery/18-laboratory-workshop.webp',
    [BuildingPrimaryPropertyType.HospitalHealthcareFacility]:
        '/assets/images/building-scenery/19-hospital-healthcare-facility.webp',
    [BuildingPrimaryPropertyType.DaySurgeryMedicalCentre]:
        '/assets/images/building-scenery/20-day-surgery-medical-centre.webp',
    [BuildingPrimaryPropertyType.SchoolEducation]:
        '/assets/images/building-scenery/21-school-education.webp',
    [BuildingPrimaryPropertyType.ChildcareCentre]:
        '/assets/images/building-scenery/22-childcare-centre.webp',
    [BuildingPrimaryPropertyType.UniversityTafe]:
        '/assets/images/building-scenery/23-university-tafe.webp',
    [BuildingPrimaryPropertyType.TheatreAssemblyHall]:
        '/assets/images/building-scenery/24-theatre-assembly-hall.webp',
    [BuildingPrimaryPropertyType.ChurchPlaceOfWorship]:
        '/assets/images/building-scenery/25-church-place-of-worship.webp',
    [BuildingPrimaryPropertyType.CommunityHall]:
        '/assets/images/building-scenery/26-community-hall.webp',
    [BuildingPrimaryPropertyType.SportsFacilityStadium]:
        '/assets/images/building-scenery/27-sports-facility-stadium.webp',
    [BuildingPrimaryPropertyType.TransportTerminal]:
        '/assets/images/building-scenery/28-transport-terminal.webp',
    [BuildingPrimaryPropertyType.LibraryMuseumGallery]:
        '/assets/images/building-scenery/29-library-museum-gallery.webp',
    [BuildingPrimaryPropertyType.ShedGarageCarport]:
        '/assets/images/building-scenery/30-shed-garage-carport.webp',
    [BuildingPrimaryPropertyType.SwimmingPoolEnclosure]:
        '/assets/images/building-scenery/31-swimming-pool-enclosure.webp',
    [BuildingPrimaryPropertyType.FenceRetainingWall]:
        '/assets/images/building-scenery/32-fence-retaining-wall.webp',
    [BuildingPrimaryPropertyType.PrivateBushfireShelter]:
        '/assets/images/building-scenery/33-private-bushfire-shelter.webp',
};

export function getBuildingSceneryImage(
    propertyType: BuildingPrimaryPropertyTypeValue
): BuildingSceneryImage {
    return {
        src: BUILDING_SCENERY_IMAGE[propertyType],
        placeholder: BUILDING_SCENERY_PLACEHOLDER[propertyType],
    };
}
